import Clickable from 'components/Common/Clickable/Clickable'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Expander from 'components/utils/Expander'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import type { MouseEventHandler, PropsWithChildren } from 'react'
import { useCallback } from 'react'
import styled from 'styled-components'

const Trigger = styled(Clickable)`
  width: 100%;
  min-height: ${rem(48)};
  padding-block: ${rem(8)};
  display: grid;
  gap: ${rem(16)};
  grid-template: "content side" auto / 1fr auto;
  align-items: center;

  &:focus-visible {
    outline: 2px solid ${props => props.theme.palette.neutral.surface.lightForeground};
    outline-offset: 1px;
  }
`

const TriggerContentArea = styled(VerticalSpacer)`
  grid-area: content;
`

const TriggerSideArea = styled(Group)`
  grid-area: side;
  justify-self: end;
`

const Content = styled.div`
  padding-top: ${rem(4)};
  padding-bottom: ${rem(12)};
`

interface Props extends PropsWithChildren {
  heading: string
  defaultOpen?: boolean
}

function ExperimentPanelSection({ heading, defaultOpen = false, children }: Props) {
  const [expanded, toggleExpanded] = useToggle(defaultOpen)

  const handleTitleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
    toggleExpanded()
  }, [toggleExpanded])

  return (
    <div>
      <Trigger onClick={handleTitleClick}>
        <TriggerContentArea gap={4}>
          <BodyTextBlock variant="large" weight="bold">
            {heading}
          </BodyTextBlock>
        </TriggerContentArea>
        <TriggerSideArea direction="horizontal" verticalAlign="center" gap={12}>
          <DropdownChevron size="M" direction={expanded ? 'up' : 'down'} />
        </TriggerSideArea>
      </Trigger>
      <Expander expanded={expanded}>
        <Content>
          {children}
        </Content>
      </Expander>
    </div>
  )
}

export default ExperimentPanelSection
